module.exports = __webpack_public_path__ + "static/media/project_midias_sociais.ca095cc3.jpg";